<template src="./template.html" ></template>

<script>
// @ is an alias to /src
import myAxios from '../../functions/myAxios'
import myDate from '../../functions/myDate'
import MyTable from './Table.vue'
import MyButtons from './Buttons.vue'
import MyDate from '../../components/MyDate.vue'
import MyPersons from '../../components/MyPersons.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import MyProducts from '../../components/MyProducts.vue'
//
export default {
  name: 'ListView',
  methods: {
    getRequestParams(searchItem, searchText, page, pageCount) {
      let params = {};

      if (searchItem) {
        params["searchItem"] = searchItem;
      }

      if (searchText) {
        params["searchText"] = searchText;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageCount) {
        params["size"] = pageCount;
      }

      return params;
    },
    async retrieveData() {
      const query = this.getRequestParams(
        this.searchItem.name,
        this.searchText,
        this.page,
        this.pageCount
      );
      if (this.route === 'persons') {
        query.mahiat = this.mahiat
      } else if (['bank_accounts','products'].includes(this.route)) {
        query.disabled = this.disabled
      } else if (this.route === 'invoices' && this.product_id) {
        query.product_id = this.product_id
      }
      this.loading = true
      try {
        // console.log(query);
        //
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}`,
          params: query
        });
        // console.log(res);
        if (res && res.data && res.data.data) {
          this.data = res.data.data
          if (!res.data.count) res.data.count = res.data.data.length
          this.totalPages = Math.ceil(Number(res.data.count) / this.pageCount)
          if (this.page != res.data.page) {
            this.page = res.data.page
          }
          this.data.forEach((row) => {
            if (this.route === 'invoices' && row.type === 'فروش') {
              row.printInvoice = true
              if (!row.lending) row.printLabel = true
            } else if (this.route === 'lendings' && row.type === 'پرداخت کالا') {
              row.printLabel = true
            } else if (this.route === 'persons' && ['person', 'other'].includes(row.type[0])) {
              row.printTipax = true;
            }
          })
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async setDateValue(item) {
      this.searchText = item
      this.retrieveData()
    },
    async set3zero(item) {
      this.searchItem = item
    },
    handleChangeSelectItem() {
      if (this.searchItem.name === 'create_date' || this.searchItem.name === '_id.create_date') {
        // this.searchText = '1401/12/27'
        this.searchText = myDate.toJalaali(new Date()).date
      } else {
        this.searchText = ''
      }
      // this.searchText = ''
      // this.page = 1
      // this.retrieveData()
    },
    handleChange() {
      this.page = 1
      this.retrieveData()
    },
    handlePageChange(value) {
      if (Number(this.$router.currentRoute.params.PageNum) !== Number(value)) {
        let url = `/${this.route}/page/${value}`
        // if (type) {
        //   url = `/${this.route}/${type}/page/${value}`
        // }
        this.$router.push({
          path: url
        }) // -> /banks/page/123
        this.retrieveData()
      }
    },
    handlePageCountChange(size) {
      this.pageCount = size
      this.page = 1
      this.retrieveData()
    },
    debounceSearch() {
      clearTimeout(this.debounce)
      //
      this.debounce = setTimeout(() => {
        if (this.searchItem.name === 'create_date' || this.searchItem.name === '_id.create_date') {
          if (!myDate.isValidJalaaliDate(this.searchText)) {
            return;
          }
        }
        this.page = 1
        this.retrieveData()
      }, 300)
    },
  },
  async created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    this.headers = this.$store.getters.pageInfo.headers
    this.searchItems = this.$store.getters.pageInfo.searchItems
    if (this.searchItems && this.searchItems.length) {
      this.searchItem = this.searchItems[0]
    }
    let page = this.$router.currentRoute.path.split("/")[3]
    this.page = Number(page)
    if ((this.searchItems.length) && (this.searchItem.name === 'create_date' || this.searchItem.name === '_id.create_date')) {
      this.searchText = myDate.toJalaali(new Date()).date
    } else {
      this.retrieveData()
    }
  },
  async mounted() {
    if (this.$refs.search) {
      this.$refs.search.focus()
    } else if (this.$refs.vradio) {
      this.$refs.vradio.$el.children[0].children[1].focus()
    }
  },
  data: () => ({
    loading: true,
    data: [],
    searchItem: [],
    searchText: "",
    disabled: "false",
    mahiat: "all",
    //only invoices
    product_id: null,
    //
    // expanded: [],
    //
    page: 0,
    totalPages: 0,
    pageCount: 15,
    itemsPerPage: [15, 25, 50],
  }),
  components: {
    MyTable,
    MyButtons,
    MyDate,
    MyPersons,
    MyCurrency,
    MyProducts,
  },
}
</script>

<style lang="scss">
.mypadding {
    padding-right: 5px;
    padding-left: 5px;
}
</style>
